import React, { useEffect, useState } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import { DeleteIcon } from 'cokitchen-icons';
import AddressInput from 'components/base/address-input';

const AddBranchAddresses = () => {
  const { addressesFormData, setAddressesFormData, setIsDisabled } = useGetStartedActionsContext();
  const [noBranch, setNoBranch] = useState(false);

  const addAddress = () => {
    const addresses = [
      ...addressesFormData,
      {
        address: '',
        latitude: 0,
        longitude: 0
      }
    ];
    setAddressesFormData(addresses);
  };

  const updateAddress = (address: string, index: number) => {
    const addresses = [...addressesFormData];
    const newAddress = { ...addresses[index], address };
    addresses[index] = newAddress;
    setAddressesFormData(addresses);
  };

  useEffect(() => {
    if (noBranch) setAddressesFormData([{ address: '', latitude: 0, longitude: 0 }]);
  }, [noBranch]);

  useEffect(() => {
    const disabled = !noBranch && addressesFormData.some((data) => !data.address);
    setIsDisabled(disabled);
  }, [addressesFormData, noBranch]);

  return (
    <div className='max-w-[390px] flex flex-col gap-10'>
      <article className='flex flex-col gap-3'>
        <h3 className='text-[32px] leading-[41.6px] font-semibold'>Add branch addresses</h3>
        <p className='text-gray-9'>
          Add company branch addresses as delivery destinations for orders, allowing both employees
          and HR to choose their preferred location.
        </p>
      </article>
      <div className='flex flex-col gap-4'>
        {addressesFormData.map((data, index) => (
          <div key={index} className='flex flex-col gap-3'>
            <AddressInput
              label={`Branch ${index + 1}`}
              placeholder='19 Lekki  Phase 1, lekki'
              value={data.address}
              onChange={(address) => updateAddress(address, index)}
            />
            {index > 0 ? (
              <button
                className='flex items-center gap-2 text-sm text-red-5'
                onClick={() =>
                  setAddressesFormData(addressesFormData.filter((_, i) => i !== index))
                }>
                <DeleteIcon />
                <span>Remove</span>
              </button>
            ) : null}
          </div>
        ))}
        <div className='flex items-center justify-between gap-2'>
          <Input
            type='checkbox'
            id='no-branch'
            label='We do not have another branch'
            onChange={(e) => setNoBranch(e.target.checked)}
            className='text-red-5'
          />
          <button className='text-sm text-blue-8 font-medium' onClick={addAddress}>
            + Add branch
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBranchAddresses;
